import React, {PropsWithChildren, useContext} from "react";
import {PreloaderContext} from "../../context/PreloaderContext";

import "./MiddlePagePreloader.scss"

export const MiddlePagePreloader: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const preloaderContext = useContext(PreloaderContext);

    const getPreloaderClassName = () => {
        return 'middle-page-preloader' + (preloaderContext.isMiddlePagePreloaderVisible ? ' visible' : '');
    }

    return (
        <div className={getPreloaderClassName()}>
            <div className={'middle-page-container'}>
                <svg id="fieldpulse-preloader-logo" xmlns="http://www.w3.org/2000/svg"
                     xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" shapeRendering="geometricPrecision"
                     textRendering="geometricPrecision" width="256" height="256">
                    <g id="fieldpulse-preloader-logo-path1_ts"
                       transform="translate(52.446852,207.001503) scale(0.500000,0.500000)">
                        <path id="fieldpulse-preloader-logo-path1"
                              d="M61.440200,198.011000C53.425800,189.992000,44.645800,182.779000,35.225800,176.470000L27.904200,171.576000L17.019000,212.480000L20.336800,215.040000C24.841300,218.515000,29.116800,222.278000,33.136800,226.304000C37.163800,230.323000,40.926400,234.598000,44.400800,239.104000L46.960800,242.427000L87.874700,231.557000L82.944200,224.256000C76.650100,214.827000,69.447700,206.037000,61.440200,198.011000Z"
                              transform="translate(-52.446852,-207.001503)" opacity="0" fill="rgb(0,148,214)"
                              stroke="none"
                              strokeWidth="1"/>
                    </g>
                    <g id="fieldpulse-preloader-logo-path2_ts"
                       transform="translate(105.748405,153.676697) scale(0.500000,0.500000)">
                        <path id="fieldpulse-preloader-logo-path2"
                              d="M121.006000,138.430000C101.745000,119.163000,80.256300,103.307000,57.144600,91.295200L50.176300,87.675400L39.741800,126.941000L43.960600,129.337000C61.813800,139.553000,78.211700,152.124000,92.713300,166.712000C106.961000,180.882000,119.291000,196.858000,129.388000,214.232000L132.506000,219.678000L171.755000,209.240000L168.136000,202.277000C156.119000,179.170000,140.288000,157.696000,121.006000,138.430000Z"
                              transform="translate(-105.748405,-153.676697)" opacity="0" fill="rgb(0,148,214)"
                              stroke="none"
                              strokeWidth="1"/>
                    </g>
                    <g id="fieldpulse-preloader-logo-path3_ts"
                       transform="translate(156.129250,103.311611) scale(0.500000,0.500000)">
                        <path id="fieldpulse-preloader-logo-path3"
                              d="M248.253000,181.283000C231.424000,144.896000,207.790000,111.324000,177.946000,81.484800C172.651000,76.190700,167.194000,71.081000,161.285000,65.848300L157.701000,62.643200C151.015000,56.939500,144.108000,51.430400,137.093000,46.213100L134.810000,44.574700C117.051000,31.618200,98.060000,20.441900,78.110900,11.207700L71.316600,8.074230L60.856500,47.498200L65.561800,49.745900C96.112800,64.332800,124.406000,84.561900,149.658000,109.788000C174.909000,135.014000,195.072000,163.286000,209.731000,193.848000L211.978000,198.549000L251.402000,188.083000L248.253000,181.283000Z"
                              transform="translate(-156.129250,-103.311611)" opacity="0" fill="rgb(0,148,214)"
                              stroke="none"
                              strokeWidth="1"/>
                    </g>
                </svg>
            </div>
        </div>
    )
}